import { render, staticRenderFns } from "./_team.vue?vue&type=template&id=2eb5c6a3&"
import script from "./_team.vue?vue&type=script&lang=js&"
export * from "./_team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports